import { HttpEvent, HttpHandler, HttpRequest, HttpInterceptor } from '@angular/common/http';
import { inject } from '@angular/core';
import { Injectable } from '@angular/core';

import { Store } from '@ngxs/store';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GoToProfilePopUp } from '@features/patients/store/patient-existing/patient-existing.actions';

@Injectable()
export class PatientProfileInterceptor implements HttpInterceptor {
  private store = inject(Store);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError(error => {
        if ((error.error || {}).goToProfile) {
          this.store.dispatch(new GoToProfilePopUp(error?.error?.patientId, error?.error?.message));
        }
        return throwError(() => error);
      }),
    );
  }
}
